import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import Pagination from 'react-js-pagination'
import AttractionActions from '../../Redux/AttractionRedux'
import CouponActions from '../../Redux/CouponRedux'

class IndividualAttraction extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      detail: {},
      form: {
        discountable_type: 'attraction',
        discountable_id: ''
      },
      page: 1,
      q: ''
    }
  }

  componentDidMount = () => {
    this.props.attractionSearch({ q: this.state.q, page: this.state.page })
  }

  _toggleModal = (modalID = null) => {
    this.setState({ showModal: modalID })
  }

  _selectItem = (item, modalID) => {
    this.setState({ detail: item })
    this._toggleModal(modalID)
  }

  _changePage = (page) => {
    this.setState({ page })
    const data = {
      q: this.state.q,
      page
    }
    this.props.attractionSearch(data)
  }

  _inputChange = (event) => {
    let val = event.target.value
    this.setState({ q: val })
  }

  _search = (event) => {
    event.preventDefault()
    const data = {
      q: this.state.q,
      page: 1
    }
    this.props.attractionSearch(data)
  }

  _submit = () => {
    let form = { ...this.state.form }
    form.discountable_id = this.state.detail.id
    if (this.props.source_type === 'coupon-user') {
      let uuid = this.props.uuid
      let data = { uuid, form }
      this.props.postCouponItem(data)
    } else {
      let tag = this.props.tag
      let data = { tag, form }
      this.props.postCouponItemTag(data)
    }
    setTimeout(() => {
      this._toggleModal()
      this.props.fetchCouponItem()
    }, 100)
  }

  _renderAttractionSelector = () => {
    const { attraction } = this.props
    return (
      <section className='section'>
        <section>
          <form className='form-group row mb-3' onSubmit={(event) => this._search(event)}>
            <div className='col-10'>
              <input type='search' name='search' placeholder='Search by Attraction name ...' className='form-control' onChange={(event) => this._inputChange(event)} />
            </div>
            <div className='col-1'>
              <button className='btn btn-primary'>
                <i className='fa fa-search' />
              </button>
            </div>
          </form>
        </section>
        <section>
          <table className='table table-hover table-striped'>
            <thead>
              <tr>
                <th className='text-center'>Title</th>
                <th className='text-center'>Provider</th>
                <th className='text-center'>Add</th>
              </tr>
            </thead>
            <tbody>
              {
                !attraction.dataSearch.data
                  ? <tr>
                    <td className='text-center' colSpan='3'>No data</td>
                  </tr>
                  : attraction.dataSearch.data.map((item, i) => (
                    <tr key={i}>
                      <td className='text-center'>{ item.title }</td>
                      <td className='text-center'>{ item.provider }</td>
                      <td className='text-center'>
                        <button className='btn btn-info' onClick={() => this._selectItem(item, 'add-attraction')}>
                          <i className='fa fa-plus' />
                        </button>
                      </td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        </section>
        <section className='text-center'>
          {
            attraction.dataSearch.page &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={attraction.dataSearch.page || this.state.page}
              itemsCountPerPage={10}
              totalItemsCount={attraction.dataSearch.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
        <Modal center open={this.state.showModal === 'add-attraction'} onClose={this._toggleModal}>
          <div className='title-block'>
            <h3 className='title'>Confirm Add Item</h3>
          </div>
          <div>
            <p>For attraction: {this.state.detail.title}</p>
          </div>
          <div className='text-center'>
            <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Cancel</button>
            <button className='btn btn-lg btn-primary' onClick={() => this._submit()}>Confirm</button>
          </div>
        </Modal>
      </section>
    )
  }

  render () {
    return (
      <section className='section'>
        <div>
          { this._renderAttractionSelector() }
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  attraction: state.attraction,
  coupon: state.coupon
})

const dispatchToProps = (dispatch) => ({
  attractionSearch: (data) => dispatch(AttractionActions.attractionSearchRequest(data)),
  postCouponItem: (data) => dispatch(CouponActions.postCouponItemRequest(data)),
  postCouponItemTag: (data) => dispatch(CouponActions.postCouponItemTagRequest(data))
})

export default connect(stateToProps, dispatchToProps)(IndividualAttraction)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/IndividualAttraction.js